/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { StringEmpty } from './helper'
import { GenericType } from '../types/commonTypes'

const indexedDBHelper = {
  defaultCacheName: (): string | null => {
    // these data will generate after user login authentication
    const localEmpId = localStorage.getItem('employeeId') as string
    const localUserName = localStorage.getItem('userName') as string

    if (StringEmpty(localEmpId) || StringEmpty(localUserName)) {
      return null
    }

    return `${localUserName}${localEmpId}`
  },

  set: async (key: string, value: any): Promise<void> => {
    const cache = await caches.open(
      indexedDBHelper.defaultCacheName() as string,
    )
    const response = new Response(JSON.stringify(value), {
      headers: { 'Content-Type': 'application/json' },
    })
    await cache.put(`/${key}`, response) // Store the data in the cache
  },

  get: async (key: string): Promise<any | undefined> => {
    const cache = await caches.open(
      indexedDBHelper.defaultCacheName() as string,
    )
    const response = await cache.match(`/${key}`)
    if (response) {
      return response.json() // Retrieve and parse the data
    } else {
      return undefined // Return undefined if not found
    }
  },

  delete: async (key: string): Promise<void> => {
    const cache = await caches.open(
      indexedDBHelper.defaultCacheName() as string,
    )
    await cache.delete(`/${key}`) // Remove the data associated with the key
  },

  getAllCacheEntries: async (): Promise<any[]> => {
    const allEntries: any[] = []
    try {
      const cacheNames = await caches.keys()

      for (const cacheName of cacheNames) {
        const cache = await caches.open(cacheName)
        const requests = await cache.keys()
        for (const request of requests) {
          const response = await cache.match(request)
          if (response) {
            const data = await response.json()
            allEntries.push({ key: request.url, value: data })
          }
        }
      }
    } catch (error) {
      console.error('Error retrieving cache entries:', error)
    }
    return allEntries
  },

  getEmployeeCache: async <T>(cacheKey: string): Promise<GenericType<T>> => {
    const cachedValue = await indexedDBHelper.get(cacheKey)
    if (cachedValue) {
      return cachedValue as GenericType<T>
    } else {
      return undefined as unknown as GenericType<T>
    }
  },

  updateEmployeeCache: async <T>(
    cacheKey: string,
    newValues: GenericType<T>,
  ): Promise<boolean> => {
    const existingValue = await indexedDBHelper.getEmployeeCache<T>(cacheKey)
    if (existingValue) {
      // Merge the new values with the existing values
      const updatedValues = { ...existingValue, ...newValues }
      await indexedDBHelper.set(cacheKey, updatedValues) // Update cache
      return true
    } else {
      return false
    }
  },
}

export default indexedDBHelper
